export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  NOT_INFORMED = 'notInformed',
}

export enum MaritalStatus {
  MARRIED = 'married',
  SINGLE = 'single',
  WIDOWER = 'widower',
  DIVORCED = 'divorced',
}

export const formattedGender = {
  [Gender.MALE]: 'M',
  [Gender.FEMALE]: 'F',
  [Gender.NOT_INFORMED]: 'N',
};

export const formattedMaritalStatus = {
  [MaritalStatus.MARRIED]: 'C',
  [MaritalStatus.SINGLE]: 'S',
  [MaritalStatus.WIDOWER]: 'V',
  [MaritalStatus.DIVORCED]: 'D',
};
